<template>
  <div class="show-wrap">
    <div class="banner"></div>
    <div class="tab-wrap">
      <ul class="tabs">
        <li class="tab" :class="{ active: activeIndex === 1 }" @click="handleIndex(1)">关于CG艺术展</li>
        <li class="tab" :class="{ active: activeIndex === 2 }" @click="handleIndex(2)">展映现场</li>
        <li class="tab" :class="{ active: activeIndex === 3 }" @click="handleIndex(3)">线下沙龙</li>
        <li class="tab" :class="{ active: activeIndex === 4 }" @click="handleIndex(4)">展映用机</li>
        <li class="tab" :class="{ active: activeIndex === 5 }" @click="handleIndex(5)">更多资讯</li>
      </ul>
    </div>
    <div class="tab-wrap sticky-tabs" v-if="showStickyTab">
      <ul class="tabs">
        <li class="tab" :class="{ active: activeIndex === 1 }" @click="handleIndex(1)">关于CG艺术展</li>
        <li class="tab" :class="{ active: activeIndex === 2 }" @click="handleIndex(2)">展映现场</li>
        <li class="tab" :class="{ active: activeIndex === 3 }" @click="handleIndex(3)">线下沙龙</li>
        <li class="tab" :class="{ active: activeIndex === 4 }" @click="handleIndex(4)">展映用机</li>
        <li class="tab" :class="{ active: activeIndex === 5 }" @click="handleIndex(5)">更多资讯</li>
      </ul>
    </div>
    <div class="content-item top-video" id="top-video">
    </div>
    <div class="content-item about">
      <img class="subtitle" src="../assets/img/exhibition/about.png" alt="">
      <img class="frame frame1" src="../assets/img/exhibition/frame-1.png" alt="">
      <div class="about-content">
        <div class="about-left">
          <div class="about-left-top">
            <span :class="{ active: videoType === 1 }" @click="videoType = 1">学术指导致辞</span>
            <span :class="{ active: videoType === 2 }" @click="videoType = 2">大咖寄语</span>
          </div>
          <div class="about-left-bottom">
            <div v-show="videoType === 1" id="about1"></div>
            <div v-show="videoType === 2" id="about2"></div>
          </div>
        </div>
        <div class="about-right">
          <div class="about-right-top" @click="goTo('https://designvue.benq.com.cn/2021/contestDetail')">关于“风潮由我”明基设计大赛 <img
              class='arrow' src="../assets/img/exhibition/arrow.png" alt=""></div>
          <p class="about-right-bottom">
            在当下如火如荼的国风浪潮下，明基BenQ携手CG模型网于2022年5月21日-29日，带着对设计力多种可能性的探索，在长沙谢子龙影像艺术馆里共同举办“风潮由我-CG数字艺术展”。<br>
            展览旨在为青年设计师提供展示创意和作品的舞台，让更多热爱国风国潮文化的设计艺术爱好者、关注中国原创设计的人看到中国设计新生力量，推动中国制造转型中国设计与中国创造。<br>
            此次展览亦是对2021“风潮由我”设计大赛的延续，大赛由“自由单元”和“主题单元”组成，涵盖了平面、动画两个方向。<br>
            活动发起后备受新生设计师关注，共收到2635份来自全国各地的作品，经过层层筛选，数轮角逐，从中遴选17幅佳作参与本次展览。
          </p>
        </div>
      </div>
    </div>
    <div class="content-item scene">
      <img class="subtitle" src="../assets/img/exhibition/scene.png" alt="">
      <img class="frame" src="../assets/img/exhibition/frame-2.png" alt="">
      <div class="scene-content">
        <div class="scene-top">
          <div class="link">直击现场 <img class='arrow' src="../assets/img/exhibition/arrow.png" alt=""></div>
          <div class="scene-top-video" id="scene-top-video">
          </div>
          <div class="link link1">参展艺术家 <img class='arrow' src="../assets/img/exhibition/arrow.png" alt=""></div>
          <p>
            <span> 特邀艺术家/机构（排名不分先后）：</span>王蔚、欧阳鹏杰、清喵、俊靈、韩锐、沙锋、三白蝉、雯方、MP Studio
            &明子、有个榴莲工作室、VVXIE设计工作室、幻想狮、倪先森、摩塔时空、蓝铅笔、奥艺文化、集映画、顶壹科技
          </p>
          <p><span> 明基设计大赛获奖者（排名不分先后）：</span>石积清、王一惠、李玉、陈嘉林、王凯硕、Toshe、曾作尧、王堃燕、戴玮、王婧杰、李根、肖经沛、刘永树、黄宇珊、孙雅喃、项威、赵鑫、高展鹏</p>
          <p>
            现场不仅展映了2021“风潮由我”明基设计大赛的获奖作品和清喵、俊霊、沙锋、三白蝉等特邀大咖的代表作，还有麓小西、奥依等“元宇宙虚拟偶像”IP海报，精彩的动捕互动展示，更通过明基投影仪设置了翻书互动、无线投屏互动、拍照打卡等众多互动环节，吸引了上百位来自设计行业的精英从业者，展映期间有一万三千余人次观展。
          </p>
        </div>
        <div class="scene-bottom">
          <div class="link">更多花絮 <img class='arrow' src="../assets/img/exhibition/arrow.png" alt=""></div>
          <div class="scene-videos">
            <div id="scene-video1"></div>
            <div id="scene-video2"></div>
          </div>
          <div class="swiper">
            <el-carousel trigger="click" height="675px" indicator-position="none" arrow="always">
              <el-carousel-item v-for="(item, i) in scenePics" :key="i">
                <img :src="'' + item + '?x-oss-process=image/resize,m_fill,h_675,w_1250,limit_0'" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <div class="content-item salon">
      <img class="subtitle" src="../assets/img/exhibition/salon.png" alt="">
      <img class="frame" src="../assets/img/exhibition/frame-2.png" alt="">
      <div class="salon-content">
        <div class="salon-video" id="salon-video"></div>
        <p>
          开幕式上，活动主办方、承办方以及学术指导穆之飞老师、活动指导单位分别进行了致辞及讲话，大赛平面组评委代表、OYART插画工作室创始人欧阳鹏杰、大赛主题单元平面组一等奖获得者石积清、主题单元动画组一等奖获得者戴玮、站酷设计师清喵分享了对这次展映的感想，湖南大学建筑学院副教授王蔚、RUIS锐兮创始人/故宫宫廷文化合作插画师韩锐、湖南天闻地铁传媒副总彭涛以“设计力”为主题，展开了精彩的圆桌跨界思辨。
        </p>
        <div class="salon-pics">
          <img
            src="http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/salon01.jpg?x-oss-process=image/resize,m_fill,h_438,w_780,limit_0"
            alt="">
          <img
            src="http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/salon02.jpg?x-oss-process=image/resize,m_fill,h_438,w_780,limit_0"
            alt="">
          <img
            src="http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/salon03.jpg?x-oss-process=image/resize,m_fill,h_438,w_780,limit_0"
            alt="">
        </div>
      </div>
    </div>
    <div class="content-item device">
      <img class="subtitle" src="../assets/img/exhibition/device.png" alt="">
      <img class="frame" src="../assets/img/exhibition/frame-2.png" alt="">
      <div class="device-content">
        <div class="device-left">
          <img
            src="http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/machine01.jpg?x-oss-process=image/resize,m_fill,h_332,w_550,limit_0"
            alt="" @click="goTo('https://item.jd.com/100004470695.html')">
          <p class="device-index" @click="goTo('https://item.jd.com/100004470695.html')">明基PD3220U专业设计显示器</p>
          <p @click="goTo('https://mp.weixin.qq.com/s/zV2jOAHNeEkuvmP0eRL-aA')" class="device-slogan">PD系列专业显示器助力设计产业
            <img class='arrow1' src="../assets/img/exhibition/arrow.png" alt="">
          </p>
        </div>
        <div class="device-right">
          <img
            src="http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/machine02.jpg?x-oss-process=image/resize,m_fill,h_332,w_550,limit_0"
            alt="" @click="goTo('https://item.jd.com/100014418662.html')">
          <p class="device-index" @click="goTo('https://item.jd.com/100014418662.html')">明基E582智能投影仪</p>
          <p @click="goTo('https://mp.weixin.qq.com/s/5U1Li1aGKODu8I6bCV78tw')" class="device-slogan">E系列智能投影打造展览新形态
            <img class='arrow1' src="../assets/img/exhibition/arrow.png" alt="">
          </p>
        </div>
      </div>
    </div>
    <div class="content-item more">
      <img class="subtitle" src="../assets/img/exhibition/more.png" alt="">
      <img class="frame frame2" src="../assets/img/exhibition/frame-2.png" alt="">
      <el-carousel class="more-swiper" trigger="click" height="675px" indicator-position="none" arrow="always">
        <el-carousel-item v-for="(item, i) in newsPics" :key="i">
          <img :src="item + '?x-oss-process=image/resize,m_fill,h_675,w_1250,limit_0'" alt="">
        </el-carousel-item>
      </el-carousel>
      <div class="indicators">
        <div
          @click="goTo('https://ishare.ifeng.com/c/s/v006DxxngyPB1XiSkRzcGhRsvhwVPah95bahqCYuyRkJVSfHw902hPQha8WwZf1KpXZkWS799wxr6kA3cF1wadcUAA____?spss=np&channelId=&aman=22uccfab32q275f879Z88af1c4s701Se1aI5ec4d1d')">
          <p>数字艺术展</p>
          <p>国风驾到</p>
        </div>
        <div @click="goTo('https://mp.weixin.qq.com/s/L7d4MJ9z1uY1gq4sMSlesQ')">
          <p>国潮设计力盛典</p>
          <p>拉开帷幕</p>
        </div>
        <div @click="goTo('https://mp.weixin.qq.com/s/T1BRM6E9Q7SN4Wodf9Yqzg')">
          <p>风潮由我</p>
          <p>圆满收官</p>
        </div>
        <div @click="goTo('https://mp.weixin.qq.com/s/DKBa1wwWeoSFnTsJZbFB8w')">
          <p>明基设计力</p>
          <p>助力多元文化</p>
        </div>
      </div>
    </div>
    <div class="footer-box">
      <div class="footer-bg">
        <img src="../assets/img/exhibition/footerBG.png" alt="">
      </div>
      <div class="beian">
        <div class="beian-box">
          <div>
            <a href="https://beian.miit.gov.cn/" target="_blank">
              <span>沪ICP备17047194号-5</span>
            </a>
          </div>
          <div class="line"></div>
          <div>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050502000550" target="_blank">
              <img src="../assets/img/ga_icon.png" alt="" />
              <span>苏公网安备32050502000550号</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Player from 'xgplayer';
import { useRouter } from "vue-router";
import { reactive } from "vue";
import { brandHit } from "../utils/apis/brandApi";
import '../utils/debounce';
import debounce from '../utils/debounce';
export default {
  name: 'Show',
  setup() {
    const router = useRouter();
    function uploadFile() {
      router.push({ path: "/upLoadFile" });
      document.documentElement.scrollTop = 820;
    }

    const logoList = reactive({
      list: [
        {
          title: "主 办 方",
          data: [
            {
              name: "明基",
              logoSrc: require("../assets/img/infoPic/BenQ.png"),
              href: "https://s.tb.cn/c.0uNQBj",
              height: "23px",
            },
          ],
        },
        {
          title: "协 办 方",
          data: [
            {
              name: "CG模型网",
              logoSrc: require("../assets/img/infoPic/moxing.png"),
              href: "https://www.cgmodel.com/",
              height: "26px",
            },
            {
              name: "蓝铅笔",
              logoSrc: require("../assets/img/infoPic/lanqianbi.png"),
              href: "https://www.lanqb.com/",
              height: "27px",
            },
            {
              name: "Wuhu",
              logoSrc: require("../assets/img/infoPic/Wuhu.png"),
              href: "https://weibo.com/u/5836279440",
              height: "45px",
            },
            {
              name: "GGAC",
              logoSrc: require("../assets/img/infoPic/GGAC.png"),
              href: "https://www.ggac.com/v2/home",
              height: "33px",
            },
          ],
        },
        {
          title: "联合品牌",
          data: [
            {
              name: "Pantone",
              logoSrc: require("../assets/img/infoPic/pantone.png"),
              href: "https://pantonecn.com",
              height: "44px",
            },
            {
              name: "CBS",
              logoSrc: require("../assets/img/infoPic/colebrook.png"),
              href: "https://mall.jd.com/view_page-257315110.html",
              height: "34px",
            },
            {
              name: "赫曼米勒",
              logoSrc: require("../assets/img/infoPic/herman.png"),
              href: "https://hermanmiller.tmall.com/",
              height: "27px",
            },
            {
              name: "绘王",
              logoSrc: require("../assets/img/infoPic/huion.png"),
              href: "https://store.huion.cn/",
              height: "24px",
            },
            {
              name: "ikbc",
              logoSrc: require("../assets/img/infoPic/ikbc.png"),
              href: "http://www.ikbc.com.cn",
              height: "28px",
            },
            {
              name: "金士顿",
              logoSrc: require("../assets/img/infoPic/kingstone.png"),
              href: "https://www.kingston.com/cn",
              height: "23px",
            },
          ],
        },
        {
          title: "支持单位",
          data: [
            {
              name: "ill",
              logoSrc: require("../assets/img/infoPic/ihdt.png"),
              href: "http://c4datc.com",
              height: "40px",
            },
            {
              name: "AD518",
              logoSrc: require("../assets/img/infoPic/ad518.png"),
              href: "http://www.ad518.com",
              height: "20px",
            },
            {
              name: "CDBC",
              logoSrc: require("../assets/img/infoPic/cdbc.png"),
              href: "https://weibo.com/207979150/",
              height: "35px",
            },
            {
              name: "涂鸦王国",
              logoSrc: require("../assets/img/infoPic/tuya.png"),
              href: "https://www.gracg.com/",
              height: "25px",
            },
          ],
        },
        {
          title: "字体支持",
          data: [
            {
              name: "造字工房",
              logoSrc: require("../assets/img/infoPic/zaozi.png"),
              href: "http://makefont.com",
              height: "40px",
            },
          ],
        },
      ],
    });

    function goLink(item) {
      brandHit({ brand: item.name }).then((res) => {
        if (res.data.code === 200) {
          window.location.href = item.href;
        }
      });
    }
    return {
      uploadFile,
      goLink,
      logoList,
    };
  },
  data() {
    return {
      activeIndex: 1,
      showStickyTab: false,
      scenePics: [
        'http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene01.jpg',
        'http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene02.jpg',
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene03.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene04.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene05.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene06.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene07.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene08.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene09.jpg"
      ],
      newsPics: [
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/news01.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/news02.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/news03.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/news04.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/news05.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/news06.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/news07.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/news08.jpg"
      ],
      //当前关于“风潮由我”CG数字艺术展视频序号
      videoType: 1
    }
  },
  methods: {
    handleIndex(index) {
      const headerHeight = document.querySelector('.tabs').clientHeight
      const a = document.querySelector('.about').offsetTop - headerHeight// 政策兑现通知公告
      const b = document.querySelector('.scene').offsetTop - headerHeight // 结果公示
      const c = document.querySelector('.salon').offsetTop - headerHeight// 职业动态
      const d = document.querySelector('.device').offsetTop - headerHeight // 产业扶持政策
      const e = document.querySelector('.more').offsetTop - headerHeight// 新闻资讯
      switch (index) {
        case 1:
          window.scrollTo({
            top: a,
            left: 0,
            behavior: 'smooth'
          })

          break
        case 2:
          window.scrollTo({
            top: b,
            left: 0,
            behavior: 'smooth'
          })
          break
        case 3:
          window.scrollTo({
            top: c,
            left: 0,
            behavior: 'smooth'
          })
          break
        case 4:
          window.scrollTo({
            top: d,
            left: 0,
            behavior: 'smooth'
          })
          break
        case 5:
          window.scrollTo({
            top: e,
            left: 0,
            behavior: 'smooth'
          })
          break
      }
    },
    goTo(url) {
      window.open(url)
    },
    initVideo(id, url, urls, poster) {
      let player = new Player({
        id,
        url,
        poster,
        definitionActive: 'click'
      });
      player.emit('resourceReady', [{ name: '流畅', url: urls[0] }, { name: '标清', url: urls[1] }, { name: '高清', url: urls[2] }, { name: '超清', url: urls[3] }]);
    }
  },
  mounted() {
    window.onscroll = debounce(() => {
      if (document.querySelector('.tabs').getBoundingClientRect().top < 0) {
        this.showStickyTab = true
      } else {
        this.showStickyTab = false
      }
      const a = document.querySelector('.about').getBoundingClientRect().top - 110  // 政策兑现通知公告
      const b = document.querySelector('.scene').getBoundingClientRect().top - 110  // 结果公示
      const c = document.querySelector('.salon').getBoundingClientRect().top - 110  // 职业动态
      const d = document.querySelector('.device').getBoundingClientRect().top - 110  // 产业扶持政策
      const e = document.querySelector('.more').getBoundingClientRect().top - 110  // 新闻资讯
      if (a <= 0 && b > 0) this.activeIndex = 1
      else if (b <= 0 && c > 0) this.activeIndex = 2
      else if (c <= 0 && d > 0) this.activeIndex = 3
      else if (d <= 0 && e > 0) this.activeIndex = 4
      else if (e <= 0) this.activeIndex = 5
      else if (a > 0) this.activeIndex = 1
    }
      , 5)
    this.initVideo('top-video', 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/documentary-540.mp4', [
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/documentary-360.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/documentary-540.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/documentary-720.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/documentary-1080.mp4'
    ], 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/documentary-poster.jpg?x-oss-process=image/resize,m_fill,h_675,w_1200,limit_0'
    )
    this.initVideo('about1', 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/academic-360.mp4', [
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/academic-360.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/academic-540.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/academic-720.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/academic-1080.mp4'
    ], 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/academic-poster.jpg?x-oss-process=image/resize,m_fill,h_352,w_626,limit_0'
    )
    this.initVideo('about2', 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/expert-360.mp4', [
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/expert-360.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/expert-540.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/expert-720.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/expert-1080.mp4'
    ], 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/expert-poster.jpg?x-oss-process=image/resize,m_fill,h_352,w_626,limit_0'
    )
    this.initVideo('scene-top-video', 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene-360.mp4', [
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene-360.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene-540.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene-720.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene-1080.mp4'
    ], 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/scene-poster.jpg?x-oss-process=image/resize,m_fill,h_675,w_1200,limit_0'
    )
    this.initVideo('scene-video1', 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit01-360.mp4', [
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit01-360.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit01-540.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit01-720.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit01-1080.mp4'
    ], 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit01-poster.jpg?x-oss-process=image/resize,m_fill,h_352,w_626,limit_0'
    )
    this.initVideo('scene-video2', 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit02-360.mp4', [
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit02-360.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit02-540.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit02-720.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit02-1080.mp4'
    ], 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/titbit02-poster.jpg?x-oss-process=image/resize,m_fill,h_352,w_626,limit_0'
    )
    this.initVideo('salon-video', 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/salon-360.mp4', [
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/salon-360.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/salon-540.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/salon-720.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/salon-1080.mp4'
    ], 'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/salon-poster.jpg?x-oss-process=image/resize,m_fill,h_675,w_1200,limit_0'
    )
  }
}

</script>

<style lang="less" scoped>
@font-face {
  font-family: "FZLanTingHeiS-B-GB";
  src: url("../assets/fonts/FZLTCHJW.TTF") format("truetype");
}

.show-wrap {
  user-select: none;
  min-width: 1200px;
  min-height: 800px;
  background-image: url("../assets/img/detailPic/bg.png") !important;
  background-size: cover;
  background-position: center;
  position: relative;

  .banner {
    height: 42.7vw;
    background: url("https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/exhibition/banner.jpg") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    position: relative;
  }

  .tab-wrap {
    background-color: #292929;

    .tabs {
      width: 1200px;
      margin: 0 auto;
      height: 100px;
      background-color: #292929;
      display: flex;
      justify-content: space-between;
      position: relative;
      z-index: 999;

      .tab {
        width: 240px;
        height: 100px;
        font-size: 30px;
        font-family: FZLanTingHeiS-B-GB;
        color: #fef9dc;
        text-align: center;
        line-height: 100px;
        background-color: #292929;
        cursor: pointer;
      }

      .active {
        background-color: #94282e;
      }
    }
  }

  .sticky-tabs {
    width: 100%;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    z-index: 9999;
  }

  .content-item {
    width: 1200px;
    margin: 150px auto;
    position: relative;

    .arrow {
      transform: translate(10px, 10px);
    }

    .arrow1 {
      transform: translate(10px, 1px);
    }

    .subtitle {
      display: block;
      margin: 0 auto;
      text-align: center;
      margin-bottom: 120px;
      transform: translateY(-39px);
    }

    .frame {
      position: absolute;
      top: -230px;
      left: 50%;
      transform: translate(-50%);
    }


    .frame2 {
      top: -227px;
    }

    .frame1 {
      top: -217px;
    }
  }


  .top-video {
    width: 1200px !important;
    height: 675px !important;
    position: relative;
    z-index: 999;
  }

  .about {


    .about-content {
      display: flex;
      justify-content: space-between;
    }

    .about-left {
      width: 626px;
      position: relative;
      z-index: 999;

      .about-left-top {
        height: 50px;
        font-family: FZLanTingHeiS-B-GB;
        font-weight: 400;
        display: flex;
        justify-content: left;

        >span {
          display: block;
          width: 192px;
          height: 49px;
          background: #292929;
          border-radius: 10px 10px 0px 0px;
          line-height: 49px;
          font-size: 25px;
          font-family: FZLanTingHeiS-B-GB, FZLanTingHeiS-B-GB-Regular;
          font-weight: 400;
          text-align: center;
          color: #fef9dc;
          letter-spacing: 0.5px;
          margin-right: 5px;
        }

        >span:hover {
          background: #932a2e;
        }

        .active {
          background: #932a2e;
        }
      }

      .about-left-bottom {
        width: 626px;
        height: 352px;

        >div {
          width: 626px !important;
          height: 352px !important;
        }
      }

    }

    .about-right {
      width: 553px;
      position: relative;
      z-index: 999;

      .about-right-top {
        height: 50px;
        font-size: 25px;
        font-family: FZLanTingHeiS-B-GB;
        font-weight: 400;
        color: #58260b;
        line-height: 50px;
        cursor: pointer;
      }

      .about-right-top:hover {
        text-decoration: underline;
        color: #932a2e
      }

      .about-right-bottom {
        font-size: 18px;
        font-family: FZLanTingHeiS-R-GB, FZLanTingHeiS-R-GB-Regular;
        font-weight: bold;
        text-align: justify;
        color: #58260b;
        line-height: 35px;
      }
    }
  }

  .scene {
    .scene-content {
      .link {
        height: 50px;
        font-size: 25px;
        font-family: FZLanTingHeiS-B-GB, FZLanTingHeiS-B-GB-Regular;
        font-weight: 400;
        text-align: left;
        color: #58260b;
        line-height: 50px;
      }

      .link1 {
        transform: translateY(20px);
      }

      .scene-top {

        .scene-top-video {
          width: 1200px !important;
          height: 675px !important;
          margin-bottom: 35px;
        }

        >p {
          font-size: 18px;
          font-family: FZLanTingHeiS-R-GB, FZLanTingHeiS-R-GB-Regular;
          font-weight: bold;
          text-align: justifyLeft;
          color: #58260b;
          line-height: 40px;
          margin: 20px auto;

          >span {
            color: #932a2e;

          }
        }
      }

      .scene-bottom {
        margin-top: 72px;

        .scene-videos {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;

          >div {
            width: 590px !important;
            height: 332px !important;

          }
        }

        .swiper {
          width: 1200px;
          height: 675px;

          img {
            width: 1200px;
            height: 675px;
          }
        }
      }
    }
  }

  .salon {
    .salon-content {
      .salon-video {
        width: 1200px !important;
        height: 675px !important;
      }

      >p {
        font-size: 18px;
        font-family: FZLanTingHeiS-R-GB, FZLanTingHeiS-R-GB-Regular;
        font-weight: bold;
        text-align: justifyLeft;
        color: #58260b;
        line-height: 40px;
        margin: 40px auto;
      }

      .salon-pics {
        display: flex;
        justify-content: space-between;

        >img {
          width: 390px;
          height: 219px;
        }
      }
    }
  }

  .device {
    .device-content {
      display: flex;
      justify-content: space-between;
      position: relative;
      z-index: 999;

      .device-left,
      .device-right {
        display: flex;
        flex-direction: column;
        align-items: center;

        >img {
          width: 590px;
          height: 332px;
          margin-bottom: 19px;
          cursor: pointer;
        }

        >p {
          font-size: 25px;
          font-family: FZLanTingHeiS-B-GB, FZLanTingHeiS-B-GB-Regular;
          font-weight: 400;
          text-align: center;
          color: #58260B;
        }

        .device-index {
          font-size: 18px;
          margin-bottom: 29px;
          cursor: pointer;
        }

        .device-slogan {
          cursor: pointer;
        }

        .device-slogan:hover,
        .device-index:hover {
          text-decoration: underline;
          color: #932a2e;
        }
      }
    }
  }

  .more {
    >p {
      height: 80px;
      font-size: 30px;
      font-family: FZLanTingHeiS-B-GB, FZLanTingHeiS-B-GB-Regular;
      font-weight: bold;
      text-align: center;
      color: #58260b;
      line-height: 80px;
    }

    .more-swiper {
      img {
        width: 1200px;
        height: 675px;
      }

    }

    .indicators {
      height: 100px;
      background-color: #292929;
      display: flex;
      justify-content: space-between;

      >div {
        width: 300px;
        height: 80px;
        padding: 10px 0;
        text-align: center;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
        cursor: pointer;

        >p {
          font-size: 25px;
          font-family: FZLanTingHeiS-R-GB, FZLanTingHeiS-R-GB-Regular;
          font-weight: bold;
          text-align: center;
          color: #fef9dc;
          line-height: 35px;
        }
      }

      >div:hover {
        background: #962e30;
      }
    }
  }

  .footer-box {
    // height: 330px;
    box-sizing: border-box;

    .footer-bg {
      background: #272727;
      width: 100%;
      height: 378px;
      padding-top: 72px;
      padding-bottom: 72px;

      >img {
        display: block;
        margin: 0 auto;
        width: 1919px;
      }
    }

    .beian {
      // height: 174px;
      // line-height: 174px;
      text-align: center;
      color: #7e3e34;
      padding-top: 20px;

      .beian-box {
        padding: 12px 0 13px;
        text-align: center;

        div {
          display: inline-block;
          font-size: 12px;
          color: rgb(152, 152, 152);

          a {
            text-decoration: none;
            color: rgb(152, 152, 152);
          }

          img {
            height: 12px;
            width: 12px;
            vertical-align: middle;
            // margin-top: 3px;
            margin-right: 6px;
          }
        }

        .line {
          vertical-align: middle;
          background: rgb(152, 152, 152);
          height: 12px;
          font-size: 12px;
          margin: 0 10px;
          width: 1px;
        }
      }
    }
  }
}
</style>